/**
 * renderContentHtml(content)
 *
 * Render admin-authored content for client-side display. Admin's blog
 * editor and SEO page editor both store rich HTML (with `<h1>`, `<h2>`,
 * `<p>`, `<ul>`, `<a>`, etc.) AND occasionally store plain text with
 * `\n\n` paragraph separators.
 *
 * Earlier versions naively ran `content.replace(/\n/g, '<br/>')` on
 * everything which mangled HTML — it injected `<br/>` between
 * `<h1>` and `<p>` tags producing odd vertical whitespace and
 * sometimes hiding real headings. The build-time prerender was
 * fixed in v3.67; this client-side helper applies the same rule so
 * the React-rendered page matches the prerendered HTML.
 *
 * Rules:
 *   • If content looks like HTML (any common tag detected) → return
 *     as-is. The browser handles whitespace; admin HTML is trusted.
 *   • Otherwise (plain text / Markdown-lite) → split on blank lines
 *     and wrap each paragraph in `<p>`. Single newlines inside a
 *     paragraph become `<br/>`.
 */
export function renderContentHtml(content) {
  if (!content) return '';
  const raw = String(content);
  const looksLikeHtml = /<\/?(p|h[1-6]|ul|ol|li|strong|em|a|br|img|blockquote|div|span|table)\b/i.test(raw);
  if (looksLikeHtml) return raw;
  // Plain text: paragraph-wrap on blank lines, single newlines → <br/>
  return raw
    .split(/\n{2,}/)
    .map((para) => `<p>${para.trim().replace(/\n/g, '<br/>')}</p>`)
    .join('\n');
}
